// Keep the subject visible when portrait photos fill landscape banners/cards.
export const imageFocalPoints: Record<string, string> = {
  '/images/cabins/levikka-exterior.jpg': '50% 100%',
};
